module.exports = __webpack_public_path__ + "img/menu.43feb6a3.svg";